import { render, staticRenderFns } from "./DrawingToolbar.vue?vue&type=template&id=48a34c82&scoped=true&"
import script from "./DrawingToolbar.vue?vue&type=script&lang=ts&"
export * from "./DrawingToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./DrawingToolbar.vue?vue&type=style&index=0&id=48a34c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a34c82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
